<template>
    <modal id="update-role">
        <template slot="title">Update Role</template>
        <template slot="body">
            <role-form :form="form"></role-form>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-default" @click="closeModal('update-role')">Cancel</button>
            <button type="button" class="btn btn-success" :disabled="form.isSubmitted" @click="save()">Update</button>
        </template>
    </modal>
</template>
<script>
    export default {

        props: {
            role: {
                required: true,
                type: Object,
            },
            roles: {
                type: Array,
                required: true,
            }
        },

        data() {
            return {
                form: new Form(this.role, false)
            }
        },

        methods: {

            /**
             * Send a request to update the modal.
             */
            save() {
                this.form.put(`/management/roles/${this.role.id}`).then(response => {
                    this.closeModal('update-role')
                    this.form = new Form(response)
                    var index = this.roles.indexOf(this.role);
                    this.roles[index] = response;
                }).catch(errors => {
                    Alert.error(errors.first());
                });
            },
        },

        watch: {
            role(newValue) {
                this.form = new Form(newValue)
            }
        },
    }
</script>
